import {Styles} from "../Styles";
import {StatusMember} from "../../../Provider/useSquadInterfaces";
import React, {useMemo} from "react";
import useSquad from "../../../Provider/useSquad";
import {FaHeart, FaHeartbeat, FaSkull, FaTeamspeak, FaUserShield} from "react-icons/fa";
import {FiAlertTriangle} from "react-icons/fi";
import {Elements} from "../../../Styles/Elements";

export const Summary = () => {

	const { users, squads } = useSquad();

	const allMembers = useMemo(
		() => squads.flatMap(squad => squad.members),
		[squads]
	);

	const summary = useMemo(() => {
		return allMembers.reduce(
			(acc, member) => {
				acc[member.status] += 1;
				return acc;
			},
			{
				[StatusMember.alive]: 0,
				[StatusMember.injured]: 0,
				[StatusMember.dead]: 0
			}
		);
	}, [allMembers]);

	const supportCount = useMemo(
		() => squads.filter(squad =>
			squad.specialActions.some(action => action.name === "emergencySupportRequired" && action.active)
		).length,
		[squads]
	);

	return <Styles.Overview>

		<Elements.MiniPanel value={ squads.length.toString() } label={"Aktive Squads"} Icon={ <FaTeamspeak /> } valueColor={"red"} />

		<Elements.MiniPanel value={ `${allMembers.length}/${users.length}` } label={"Spieler"} Icon={ <FaUserShield /> } valueColor={"red"} />

		<Elements.MiniPanel value={ supportCount.toString() } label={"Unterstützung"} Icon={ <FiAlertTriangle /> } valueColor={"red"} />

		<Elements.MiniPanel value={ summary[StatusMember.alive].toString() } label={"Lebend"} Icon={ <FaHeart /> } valueColor={"green"} />

		<Elements.MiniPanel value={ summary[StatusMember.injured].toString() } label={"Verletzt"} Icon={ <FaHeartbeat /> } valueColor={"yellow"} />

		<Elements.MiniPanel value={ summary[StatusMember.dead].toString() } label={"Gefallen"} Icon={ <FaSkull /> } valueColor={"red"} />
	</Styles.Overview>
}